import React, { useState, useRef } from 'react';
import { Container, Row, Col, Form, Card, InputGroup, Button } from 'react-bootstrap';
import './ConsentCodeInput.css';
import AlertDialog from 'components/Alerts/AlertDialog';

const ConsentCodeInput = ({ 
  onValidateCode, 
  onReSendCode, 
  phone, 
  codeError,
  serverError,
  onCleanError 
}) => {
  const [codeArray, setCodeArray] = useState(['', '', '', '']);
  const [reSendDisabled, setResendDisabled] = useState(false);
  const [remainingTime, setRemainingTime] = useState(60);

  const inputRefs = useRef([]);

  const handleInputChange = (index, value) => {
    if (value.length <= 1) {
      const newCodeArray = [...codeArray];
      newCodeArray[index] = value;
      setCodeArray(newCodeArray);

      if (value && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleValidateCode = () => {
    const codeNumber = codeArray.join('');
    onValidateCode(codeNumber);
  }
  
  const handleResendCode = () => {
    setResendDisabled(true);
    setRemainingTime(30);
    onReSendCode();

    const timer = setInterval(() => {
      setRemainingTime(prevTime => {
        if (prevTime === 1) {
          clearInterval(timer);
          setResendDisabled(false);
          return 30;
        }
        return prevTime - 1;
      });
    }, 1000);
  }
  
  return (
    <Container className="mb-5">
      <Row className="justify-content-md-center ">
        <Col md={6}>
          <Card className='consent-card'>
            <Card.Title className='consent-card-title'>Consentimiento Informado</Card.Title>
            <Card.Body className='consent-card-body'>
              <div className="justify-content-start mb-4">
                <h6 className='consent-card-text mb-2'>Ingresa el código que enviamos por SMS</h6>
                <h6> Te acabamos de enviar un mensaje de texto con un código de 4 dígitos. Ingrésalo aquí: </h6>
              </div>
              <InputGroup className='consent-input-container'>
                {codeArray.map((code, index) => (
                  <Form.Control 
                    key={index}
                    ref={(input) => inputRefs.current[index] = input}
                    size="sm" 
                    type="text" 
                    maxLength="1"
                    className='consent-input-text square-input'
                    value={code}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                  />
                ))}
              </InputGroup>
              <div className="d-flex justify-content-center mt-4">
                {codeError && <p style={{ color: '#FA0F00', fontWeight: 'bold', fontSize:'12px', marginLeft:'4px' }}>{codeError}</p>}
              </div>
              <div className="d-flex justify-content-center">
                  <Button 
                  variant='primary'
                  className='consent-button'
                  onClick={() =>  handleValidateCode()}
                >Validar código</Button>
              </div>
              
              <div className="d-flex justify-content-center">
                <h6 
                  onClick={ reSendDisabled ? null : handleResendCode } 
                  className='consent-link-text'
                  style={{ cursor: reSendDisabled ? 'default' : 'pointer' }}
                >{reSendDisabled 
                  ? <>Espera <span style={{ color: 'black', fontWeight:'bold' }}>{remainingTime}</span> segundos para solicitar otro código</>
                  : 'Solicitar otro código'}
                </h6>
              </div>
            </Card.Body>
          </Card>
          
        </Col>
        <AlertDialog
          show={serverError}
          title={"Error solicitar código"}
          bodyMessage={"Ocurrió un error al solicitar el código, por favor intenta nuevamente en 30 segundos."}
          buttonName={"Volver"}
          buttonFunction={() => { onCleanError() }}
          onHide={() => { onCleanError() }}
          error={true}
        />
      </Row>
    </Container>
  );
};

export default ConsentCodeInput;